export const tagManagerArgs = {
  gtmId: "GTM-WBWS9KD",
};
export const IMAGE_URL = "https://images.seekhoapp.com/static/website";
export const IMAGE_URL_2 = "https://images.seekhoapp.com/static/website/v2";
export const SITE_DESCRIPTION =
  "Seekho is India's First Edutainment OTT Platform, offering bite-sized videos on Business, Technology and Money in Multiple Indian Languages.";
export const CATEGORY_DESCRIPTION =
  "Explore more than 20 categories on Seekho app like photography, mobile tricks, technology, online business, english speaking, health, social media and so much more. Learn all in the comfort of hindi language through short videos.";
export const CONTEST_DESCRIPTION =
  "Participate in our fun contests and Giveaway programmes and get a chance to win exciting prizes. Contests and Giveaways are organised every month on the Seekho app so don't miss your chance to win exciting prizes.";
export const TERMS_AND_CONDITIONS_DESCRIPTION =
  "SEEKHO hereby grants you permission to access and use the Service as set forth in these Terms of Service, provided that: You agree not to distribute in any medium any part of the Service or the Content without SEEKHO's prior written authorization.";

export const TEAM_DESCRIPTION =
  "Meet our dedicated and diverse team of experts at Seekho. Our talented professionals bring a wealth of experience and passion to every project.";
export const APP_DESCRIPTION =
  "Explore and watch series bite-sized videos series in multiple categories our webapp.";

export const PREMIUM_HUMAN_IMG = "";
export const CATEGORY_ITEMS = "category_items";
export const MIXED_ITEMS = "mixed_items";
export const FREE_SERIES = "free_series";
export const CATEGORY_UNITS = "category_units";
export const BANNER = "banner";
export const TOP_SERIES = "top_10_series_v3";
export const GROUP_SERIES = "group_series";
export const GROUP_SERIES_2 = "group_series_v2";
export const PREMIUM_PROMOTION = "premium_promotion";
export const CATEGORY_SERIES = "category_series_v2";
export const NEW_SERIES = "new_series";
export const NEW_C_SERIES = "new_series";
export const REFER_EARN = "refer_and_earn";
export const EXPLORE_CAT = "explore_category";
export const ALL_SERIES = "all_series";
export const CONTINUE_LEARNING = "continue_learning";
export const BANNER_RECOMAND_FREE = "banner_recommand_free";
export const FREE_SERIES_V2 = "free_series_v2";

export const createMarkup = (obj) => {
  return {
    __html:
      '<script type="application/ld+json">' + JSON.stringify(obj) + "</script>",
  };
};

export const GooglePlayRedirectUrl =
  "https://play.google.com/store/apps/details?id=com.seekho.android&pli=1";

export const appleStoreRedirectUrl =
  "https://apps.apple.com/in/app/seekho-short-learning-videos/id6670752585";

export const contactNumber = "+918035737646";
export const contactEmail = "support@seekhoapp.com";
export const blogDeepLink = "https://seekhoapp.onelink.me/7wVg/eurpuy85";
export const appDeepLink = "https://seekhoapp.onelink.me/7wVg/gnn6h1fl";
